import {
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
} from '@backstage/integration-react';
import { UserSettingsStorage } from '@backstage/plugin-user-settings';

import {
  ApiBlueprint,
  configApiRef,
  discoveryApiRef,
  errorApiRef,
  fetchApiRef,
  identityApiRef,
  storageApiRef,
} from '@backstage/frontend-plugin-api';

export const scmIntegrationsApi = ApiBlueprint.make({
  name: 'scm-integrations',
  params: defineParams =>
    defineParams({
      api: scmIntegrationsApiRef,
      deps: { configApi: configApiRef },
      factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
    }),
});

export const userSettingsStorageApi = ApiBlueprint.make({
  name: 'user-settings-storage',
  params: defineParams =>
    defineParams({
      api: storageApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        errorApi: errorApiRef,
        fetchApi: fetchApiRef,
        identityApi: identityApiRef,
      },
      factory: ({ discoveryApi, errorApi, fetchApi, identityApi }) =>
        UserSettingsStorage.create({
          discoveryApi,
          fetchApi,
          errorApi,
          identityApi,
        }),
    }),
});
